export class InvoiceAmendmentDetail {
  public Id: string | null;
  public InvoiceId: string | null;
  public CreatedAt: number;
  public Code: string | null;
  public Label: string | null;
  public AmountTaxExcluded: number | null;
  public AmountTaxIncluded: number | null;
  public AmountVat: number | null;
  }
